var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcErrorCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.28516 12.7138C4.54427 13.9733 6.21875 14.6666 7.99935 14.6666C9.77995 14.6666 11.4544 13.9733 12.7135 12.7138C15.3125 10.1146 15.3125 5.8854 12.7135 3.28611C11.4544 2.02667 9.77995 1.33331 7.99935 1.33331C6.21875 1.33331 4.54427 2.02667 3.28516 3.28611C0.686198 5.8854 0.686198 10.1146 3.28516 12.7138ZM7.99963 1.99998C9.60249 1.99998 11.109 2.624 12.2425 3.75747C14.5817 6.09666 14.5817 9.9033 12.2425 12.2425C11.109 13.376 9.60249 14 7.99963 14C6.39676 14 4.89025 13.376 3.75679 12.2425C1.4176 9.9033 1.4176 6.09666 3.75679 3.75747C4.89025 2.624 6.39676 1.99998 7.99963 1.99998ZM5.40653 10.9261C5.32124 10.9261 5.23596 10.8935 5.17085 10.8284C5.04064 10.6982 5.04064 10.4873 5.17085 10.3571L7.52766 7.99998L5.17085 5.64288C5.04064 5.51267 5.04064 5.30174 5.17085 5.17153C5.30106 5.04132 5.512 5.04132 5.64221 5.17153L7.99898 7.52858L10.3557 5.17153C10.486 5.04132 10.6969 5.04132 10.8271 5.17153C10.9573 5.30174 10.9573 5.51267 10.8271 5.64288L8.47029 7.99998L10.8271 10.3571C10.9573 10.4873 10.9573 10.6982 10.8271 10.8284C10.762 10.8935 10.6767 10.9261 10.5914 10.9261C10.5061 10.9261 10.4209 10.8935 10.3557 10.8284L7.99898 8.47137L5.64221 10.8284C5.5771 10.8935 5.49182 10.9261 5.40653 10.9261Z",
    fill: "#CC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcErrorCircle);
export default __webpack_public_path__ + "static/media/ic-error-circle.5f1843470db9a57ee74a8f1b35d4dc6e.svg";
export { ForwardRef as ReactComponent };